<a class="close-section close-fixed" href="javascript:;" (click)='goToProject()'></a>